import { Link } from "react-router-dom";
import { genres } from "@/mocks/movies";
import { siteInfo } from "@/mocks/site";

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-primary-950 text-background-100">
      <div className="mx-auto grid w-full grid-cols-1 gap-8 px-4 py-12 md:px-6 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-lg text-primary-950">
              <i className="ri-movie-2-fill" />
            </span>
            <span className="font-heading text-lg font-bold text-background-50">
              {siteInfo.name}
            </span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
            {siteInfo.description}
          </p>
          <p className="mt-4 text-xs text-background-400">
            <i className="ri-mail-line mr-1" />
            {siteInfo.email}
          </p>
        </div>

        <div>
          <h3 className="font-heading text-sm font-semibold text-background-50">
            快速导航
          </h3>
          <ul className="mt-4 space-y-2.5">
            {[
              { to: "/", label: "首页" },
              { to: "/category/动作", label: "电影分类" },
              { to: "/search", label: "搜索电影" },
              { to: "/about", label: "关于我们" },
            ].map((item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  className="text-sm text-background-300 transition-colors hover:text-accent-400 cursor-pointer"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-heading text-sm font-semibold text-background-50">
            热门分类
          </h3>
          <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2.5">
            {genres.slice(0, 8).map((genre) => (
              <li key={genre.slug}>
                <Link
                  to={`/category/${genre.slug}`}
                  className="text-sm text-background-300 transition-colors hover:text-accent-400 cursor-pointer"
                >
                  {genre.name}电影
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-800">
        <div className="mx-auto flex w-full flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-background-400 md:flex-row md:px-6">
          <p>{siteInfo.copyright}</p>
          <p>{siteInfo.icp}</p>
        </div>
      </div>
    </footer>
  );
}